const sectorsAssociationColumns = {
  sector: {
    key: 'sector',
    label: 'sector',
    type: 'enum',
    enum: 'sectors',
    sortable: 'custom',
    minWidth: 230,
  },
  department: {
    key: 'department',
    label: 'department',
    type: 'enum',
    enum: 'laboratories',
    sortable: 'custom',
  },
  location: {
    key: 'location.name',
    label: 'location',
    type: 'text',
    sortable: 'custom',
    minWidth: 200,
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    buttons: [
      {
        name: 'editSector',
        icon: 'fas fa-pencil',
        permissions: ['locationSectorDepartmentManage'],
      },
      {
        name: 'deleteSector',
        icon: 'fas fa-trash-alt',
        permissions: ['locationSectorDepartmentManage'],
      },
    ],
  },
};

export default sectorsAssociationColumns;
